module.exports = __webpack_public_path__ + "static/media/onion.de054680.png";